var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("收货验收单信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showPurchReceiptFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowPurchReceipt()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showPurchReceiptFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showPurchReceiptFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showPurchReceiptFlag
        ? [
            _c("div", { staticClass: "simple-form" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.receipt.title || "无"))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.receipt.innerNo || "无"))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.buyerRealComCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.buyerRealComName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.recvComName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.buyerInnerSellerCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.sellerName || ""))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.receipt.logisFee != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(parseFloat(_vm.receipt.logisFee).toFixed(2))
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.receipt.asmblFee != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(parseFloat(_vm.receipt.asmblFee).toFixed(2))
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.receipt.setupFee != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(parseFloat(_vm.receipt.setupFee).toFixed(2))
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.receipt.tearFee != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(parseFloat(_vm.receipt.tearFee).toFixed(2))
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(11),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.receipt.toDoorFee != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(parseFloat(_vm.receipt.toDoorFee).toFixed(2))
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(12),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.receipt.repairFee != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(parseFloat(_vm.receipt.repairFee).toFixed(2))
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.receipt.otherFee != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(parseFloat(_vm.receipt.otherFee).toFixed(2))
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(14),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.receipt.amount != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(parseFloat(_vm.receipt.amount).toFixed(2))
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(15),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-select",
                      {
                        on: { change: _vm.invoiceTypeChange },
                        model: {
                          value: _vm.receipt.invoiceType,
                          callback: function($$v) {
                            _vm.$set(_vm.receipt, "invoiceType", $$v)
                          },
                          expression: "receipt.invoiceType"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "增值税-普通发票", value: 1 }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "增值税-专用发票", value: 2 }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(16),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _vm.receipt.invoiceType == 1
                      ? _c("span", [_vm._v("否")])
                      : _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            on: { change: _vm.changeTaxOffset },
                            model: {
                              value: _vm.receipt.taxOffset,
                              callback: function($$v) {
                                _vm.$set(_vm.receipt, "taxOffset", $$v)
                              },
                              expression: "receipt.taxOffset"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "是", value: true }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "否", value: false }
                            })
                          ],
                          1
                        )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(17),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择税率" },
                        on: {
                          change: function($event) {
                            _vm.changeActualAmount()
                          }
                        },
                        model: {
                          value: _vm.receipt.taxRate,
                          callback: function($$v) {
                            _vm.$set(_vm.receipt, "taxRate", $$v)
                          },
                          expression: "receipt.taxRate"
                        }
                      },
                      _vm._l(_vm.fiscalTaxMarkList, function(item) {
                        return _c("el-option", {
                          key: item.rate,
                          attrs: { label: item.rate, value: item.rate }
                        })
                      })
                    )
                  ],
                  1
                )
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("订货验收信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showPurchReceiptGoodsItemFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowPurchReceiptGoodsItem()
              }
            }
          },
          [
            _c("span", [
              _vm._v(
                _vm._s(_vm.showPurchReceiptGoodsItemFlag ? "隐藏" : "展开")
              )
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showPurchReceiptGoodsItemFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showPurchReceiptGoodsItemFlag
        ? [
            _c("div", { staticClass: "table-layout" }, [
              _vm.receipt.goodsItemList != null &&
              _vm.receipt.goodsItemList.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.receipt.goodsItemList,
                            border: "",
                            "tooltip-effect": "dark",
                            maxHeight: "400"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "assetDefNo",
                              label: "资产定义编码",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "assetDefName",
                              label: "资产定义名称",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "assetNature",
                              label: "资产属性",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.assetNatureMap[
                                            rows.row.assetNature
                                          ]
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "quantity",
                              label: "验收数量",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "innerCode",
                              label: "含税单价(元)",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.wtxPrice != null
                                      ? _c("span", [
                                          _vm._v(_vm._s(rows.row.wtxPrice))
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "innerCode",
                              label: "税率(%)",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          parseFloat(rows.row.taxRate).toFixed(
                                            2
                                          ) || 0.0
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "ntxPrice",
                              label: "未税单价(元)",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.ntxPrice != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.ntxPrice
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "innerCode",
                              label: "含税总金额(元)",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.wtxAmount != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.wtxAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "innerCode",
                              label: "未税总金额(元)",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.ntxAmount != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.ntxAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "innerCode",
                              label: "税额小计(元)",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.taxAmount != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.taxAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("费用")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showPurchReceiptFeeFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowPurchReceiptFee()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showPurchReceiptFeeFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showPurchReceiptFeeFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showPurchReceiptFeeFlag
        ? [
            _c("div", { staticClass: "simple-row" }, [
              (_vm.purchFeeNames || []).length > 0
                ? _c("div", { staticClass: "left" }, [
                    _vm.purchFeeNames.contains("LogisFee")
                      ? _c("div", { staticClass: "fl mr30" }, [
                          _c("label", { staticClass: "mr5" }, [
                            _vm._v("物流费总计(元)")
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.logisFee))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("AsmblFee")
                      ? _c("div", { staticClass: "fl mr30" }, [
                          _c("label", { staticClass: "mr5" }, [
                            _vm._v("组装费总计(元)")
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.asmblFee))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("SetupFee")
                      ? _c("div", { staticClass: "fl mr30" }, [
                          _c("label", { staticClass: "mr5" }, [
                            _vm._v("安装费总计(元)")
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.setupFee))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("TearFee")
                      ? _c("div", { staticClass: "fl mr30" }, [
                          _c("label", { staticClass: "mr5" }, [
                            _vm._v("拆除费总计(元)")
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.tearFee))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("toDoorFee")
                      ? _c("div", { staticClass: "fl mr30" }, [
                          _c("label", { staticClass: "mr5" }, [
                            _vm._v("上门费总计(元)")
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.toDoorFee))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("RepairFee")
                      ? _c("div", { staticClass: "fl mr30" }, [
                          _c("label", { staticClass: "mr5" }, [
                            _vm._v("维修费总计(元)")
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.repairFee))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("OthersFee")
                      ? _c("div", { staticClass: "fl mr30" }, [
                          _c("label", { staticClass: "mr5" }, [
                            _vm._v("其他杂费总计(元)")
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.otherFee))])
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "right" }, [
                _vm.receipt.contractId != null && _vm.receipt.contractId != -1
                  ? _c(
                      "a",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: {
                          click: function($event) {
                            _vm.selectFees()
                          }
                        }
                      },
                      [_vm._v("选择")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "swb-btn swb-btn-small",
                    on: {
                      click: function($event) {
                        _vm.addFees()
                      }
                    }
                  },
                  [_vm._v("新增")]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.receipt.feeItemList,
                  border: "",
                  "tooltip-effect": "dark",
                  maxHeight: "400",
                  "summary-method": _vm.getFeeItemSum,
                  "show-summary": ""
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "feeType",
                    label: "费用类型",
                    width: "150",
                    fixed: "",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.purchFeeTypeMap[rows.row.feeType])
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "name",
                    label: "名称",
                    fixed: "",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "brandName",
                    label: "品牌",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "modelSpec",
                    label: "规格",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "unit",
                    width: "60",
                    label: "单位"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "price",
                    align: "right",
                    width: "120",
                    label: "单价(元)"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.price != null
                            ? _c("span", [
                                _vm._v(_vm._s(rows.row.price.toFixed(2)))
                              ])
                            : _c("span", [_vm._v("0.00")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "quantity",
                    width: "120",
                    label: "数量"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: rows.row.quantity,
                                expression: "rows.row.quantity"
                              }
                            ],
                            staticClass: "align-right",
                            staticStyle: { width: "90px" },
                            attrs: {
                              type: "number",
                              size: "6",
                              min: 0,
                              max: 100000
                            },
                            domProps: { value: rows.row.quantity },
                            on: {
                              change: function($event) {
                                _vm.quantityChange(rows.row, rows.$index)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  rows.row,
                                  "quantity",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "amount",
                    align: "right",
                    width: "120",
                    label: "小计(元)"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.amount != null
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(parseFloat(rows.row.amount).toFixed(2))
                                )
                              ])
                            : _c("span", [_vm._v("0.00")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "left", label: "操作", width: "170" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.feeItemId == null
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.addFees(rows.row, rows.$index)
                                    }
                                  }
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.removeFeeItem(rows.$index)
                                }
                              }
                            },
                            [_vm._v("移除")]
                          ),
                          _vm._v(" "),
                          rows.row.feeType == 1
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.doCountFeeShare(
                                        "logis",
                                        rows.row.amount
                                      )
                                    }
                                  }
                                },
                                [_vm._v("计算分摊")]
                              )
                            : rows.row.feeType == 2
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.doCountFeeShare(
                                        "asmbl",
                                        rows.row.amount
                                      )
                                    }
                                  }
                                },
                                [_vm._v("计算分摊")]
                              )
                            : rows.row.feeType == 3
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.doCountFeeShare(
                                        "setup",
                                        rows.row.amount
                                      )
                                    }
                                  }
                                },
                                [_vm._v("计算分摊")]
                              )
                            : rows.row.feeType == 4
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.doCountFeeShare(
                                        "tear",
                                        rows.row.amount
                                      )
                                    }
                                  }
                                },
                                [_vm._v("计算分摊")]
                              )
                            : rows.row.feeType == 5
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.doCountFeeShare(
                                        "toDoor",
                                        rows.row.amount
                                      )
                                    }
                                  }
                                },
                                [_vm._v("计算分摊")]
                              )
                            : rows.row.feeType == 6
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.doCountFeeShare(
                                        "repair",
                                        rows.row.amount
                                      )
                                    }
                                  }
                                },
                                [_vm._v("计算分摊")]
                              )
                            : rows.row.feeType == 9
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.doCountFeeShare(
                                        "other",
                                        rows.row.amount
                                      )
                                    }
                                  }
                                },
                                [_vm._v("计算分摊")]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("临采验收条目")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showPurchReceiptItemFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowPurchReceiptItem()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showPurchReceiptItemFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showPurchReceiptItemFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showPurchReceiptItemFlag
        ? [
            (_vm.purchFeeNames || []).length > 0
              ? _c(
                  "div",
                  { staticClass: "simple-form small-form flex col-4 label" },
                  [
                    _vm.purchFeeNames.contains("LogisFee")
                      ? _c("div", { staticClass: "form-group center" }, [
                          _vm._m(18),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _c("span", [_vm._v(_vm._s(_vm.logisFee))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-small",
                                on: {
                                  click: function($event) {
                                    _vm.doCountFeeShare("logis", _vm.logisFee)
                                  }
                                }
                              },
                              [_c("span", [_vm._v("计算分摊")])]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("AsmblFee")
                      ? _c("div", { staticClass: "form-group center" }, [
                          _vm._m(19),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _c("span", [_vm._v(_vm._s(_vm.asmblFee))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-small",
                                on: {
                                  click: function($event) {
                                    _vm.doCountFeeShare("asmbl", _vm.asmblFee)
                                  }
                                }
                              },
                              [_c("span", [_vm._v("计算分摊")])]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("SetupFee")
                      ? _c("div", { staticClass: "form-group center" }, [
                          _vm._m(20),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _c("span", [_vm._v(_vm._s(_vm.setupFee))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-small",
                                on: {
                                  click: function($event) {
                                    _vm.doCountFeeShare("setup", _vm.setupFee)
                                  }
                                }
                              },
                              [_c("span", [_vm._v("计算分摊")])]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("TearFee")
                      ? _c("div", { staticClass: "form-group center" }, [
                          _vm._m(21),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _c("span", [_vm._v(_vm._s(_vm.tearFee))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-small",
                                on: {
                                  click: function($event) {
                                    _vm.doCountFeeShare("tear", _vm.tearFee)
                                  }
                                }
                              },
                              [_c("span", [_vm._v("计算分摊")])]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("toDoorFee")
                      ? _c("div", { staticClass: "form-group center" }, [
                          _vm._m(22),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _c("span", [_vm._v(_vm._s(_vm.toDoorFee))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-small",
                                on: {
                                  click: function($event) {
                                    _vm.doCountFeeShare("toDoor", _vm.toDoorFee)
                                  }
                                }
                              },
                              [_c("span", [_vm._v("计算分摊")])]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("RepairFee")
                      ? _c("div", { staticClass: "form-group center" }, [
                          _vm._m(23),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _c("span", [_vm._v(_vm._s(_vm.repairFee))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-small",
                                on: {
                                  click: function($event) {
                                    _vm.doCountFeeShare("repair", _vm.repairFee)
                                  }
                                }
                              },
                              [_c("span", [_vm._v("计算分摊")])]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.purchFeeNames.contains("OthersFee")
                      ? _c("div", { staticClass: "form-group center" }, [
                          _vm._m(24),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _c("span", [_vm._v(_vm._s(_vm.otherFee))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-small",
                                on: {
                                  click: function($event) {
                                    _vm.doCountFeeShare("other", _vm.otherFee)
                                  }
                                }
                              },
                              [_c("span", [_vm._v("计算分摊")])]
                            )
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "table-layout" }, [
              _vm.receipt.itemList != null && _vm.receipt.itemList.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.receipt.itemList,
                            border: "",
                            "tooltip-effect": "dark",
                            "summary-method": _vm.getDetailItemSum,
                            "show-summary": "",
                            maxHeight: "400"
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              type: "selection",
                              selectable: _vm.selectable,
                              width: "55"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "devcDefNo",
                              label: "资产定义编码",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "innerCode",
                              label: "资产编号",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "goodsTitle",
                              label: "资产名称",
                              width: "200",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "tmpNo",
                              label: "系统编号",
                              width: "220",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "assetNature",
                              label: "资产属性",
                              width: "150",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.assetNatureMap[
                                            rows.row.assetNature
                                          ]
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "catName",
                              label: "资产分类",
                              width: "120",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "brandName",
                              label: "资产品牌",
                              width: "120",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "quantity",
                              width: "80",
                              label: "数量"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "theUnit",
                              "min-width": "50",
                              label: "单位"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "xtraFee",
                              label: "分摊费用总计(元)",
                              width: "140"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.xtraFee != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.xtraFee
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _vm.purchFeeNames.contains("LogisFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "logisPrice",
                                  label: "物流费(元)",
                                  width: "90"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.logisPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  parseFloat(
                                                    rows.row.logisPrice
                                                  ).toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.purchFeeNames.contains("AsmblFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "asmblPrice",
                                  label: "组装费(元)",
                                  width: "90"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.asmblPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  parseFloat(
                                                    rows.row.asmblPrice
                                                  ).toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.purchFeeNames.contains("SetupFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "setupPrice",
                                  label: "安装费(元)",
                                  width: "90"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.setupPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  parseFloat(
                                                    rows.row.setupPrice
                                                  ).toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.purchFeeNames.contains("TearFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "tearPrice",
                                  label: "拆除费(元)",
                                  width: "90"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.tearPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  parseFloat(
                                                    rows.row.tearPrice
                                                  ).toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.purchFeeNames.contains("toDoorFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "toDoorPrice",
                                  label: "上门费(元)",
                                  width: "90"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.toDoorPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  parseFloat(
                                                    rows.row.toDoorPrice
                                                  ).toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.purchFeeNames.contains("RepairFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "repairPrice",
                                  label: "维修费(元)",
                                  width: "90"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.repairPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  parseFloat(
                                                    rows.row.repairPrice
                                                  ).toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.purchFeeNames.contains("OthersFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  prop: "otherPrice",
                                  label: "其他费(元)",
                                  width: "90"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.otherPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  parseFloat(
                                                    rows.row.otherPrice
                                                  ).toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wtxPrice",
                              align: "right",
                              width: "120",
                              label: "含税单价(元)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.wtxPrice != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.wtxPrice
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "taxRate",
                              align: "right",
                              width: "60",
                              label: "税率(%)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.taxRate != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.taxRate
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ntxPrice",
                              align: "right",
                              width: "120",
                              label: "未税单价(元)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.ntxPrice != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.ntxPrice
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "wtxAmount",
                              width: "100",
                              label: "含税小计(元)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.wtxAmount != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.wtxAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "ntxAmount",
                              width: "120",
                              label: "未税小计(元)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.ntxAmount != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.ntxAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              prop: "taxAmount",
                              width: "80",
                              label: "税额小计(元)"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.taxAmount != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                rows.row.taxAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "assetType",
                              label: "管理方式",
                              width: "60",
                              fixed: "",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    rows.row.assetType == 0
                                      ? _c("span", [_vm._v("单品式")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    rows.row.assetType == 1
                                      ? _c("span", [_vm._v("批量式")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    rows.row.assetType == 3
                                      ? _c("span", [_vm._v("组装件")])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("买家公司编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("买家公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("请购部门/门店")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("卖家标识")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("卖家名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("物流费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("组装费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("安装费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("拆除费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("上门费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("维修费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("其他杂费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("费用总计(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("是否抵扣税")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("税率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("物流费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("组装费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("安装费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("拆除费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("上门费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("维修费(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("其他杂费(元)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8953eba0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8953eba0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/PurchReceiptTmpAudit.vue
// module id = 2915
// module chunks = 0